import { setTasksVisualizationSource as setTasksVisualizationSourceDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    source?: String,
}

export const setTasksVisualizationSource = ({
    source,
    eventEmitter,
}: Props) => {
    setTasksVisualizationSourceDiagram(source);
};
